
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 81 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#E20374","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M72.903 18.412H81V26.5h-8.097v-8.088zm-24.19 0h8.098V26.5h-8.098v-8.088zm-24.189 0h8.099V26.5h-8.099v-8.088z"}}),_c('path',{attrs:{"d":"M13.334 2.006C10.01 2.1 7.407 3.195 5.53 5.292 3.746 7.3 2.657 10.372 2.264 14.51l-2.11-.362L.546.094h31.723l.392 14.054-2.11.362c-.391-4.138-1.475-7.21-3.252-9.218-1.87-2.097-4.46-3.19-7.77-3.286v29.382c0 1.517.1 2.65.305 3.396.392 1.444 1.344 2.324 2.856 2.64.747.151 1.905.226 3.471.226v2.249H6.65v-2.25c1.091 0 1.86-.017 2.313-.056 1.522-.149 2.603-.551 3.242-1.207.757-.767 1.13-2.432 1.13-4.998V2.006z"}}),_c('path',{attrs:{"d":"M.08 18.412h8.098V26.5H.08z"}})])])
          )
        }
      }
    